import { useCallback } from 'react'

import {
  CreateFinanceTaxTypeLedgerAccountAssignmentsInput,
  UpdateFinanceTaxTypeLedgerAccountAssignmentsInput,
} from 'generated/resources/graphql'

type WithAssignedLedgerAccounts<T = Record<string, never>> = T & {
  assignedLedgerAccounts: UpdateFinanceTaxTypeLedgerAccountAssignmentsInput[]
}

export type LedgerAccountAssignmentInput =
  | UpdateFinanceTaxTypeLedgerAccountAssignmentsInput
  | CreateFinanceTaxTypeLedgerAccountAssignmentsInput

export const useLedgerAccountAssignment = <T extends object>(
  setValues: (
    updater: (prevValues: WithAssignedLedgerAccounts<T>) => WithAssignedLedgerAccounts<T>
  ) => void
) => {
  return useCallback(
    (inputData: LedgerAccountAssignmentInput) => {
      setValues((prevValues) => ({
        ...prevValues,
        assignedLedgerAccounts: prevValues.assignedLedgerAccounts.some(
          (account) =>
            account.legalEntityId === inputData.legalEntityId &&
            'operationType' in account &&
            'operationType' in inputData &&
            account.operationType === inputData.operationType
        )
          ? prevValues.assignedLedgerAccounts.map((account) =>
              account.legalEntityId === inputData.legalEntityId &&
              'operationType' in account &&
              'operationType' in inputData &&
              account.operationType === inputData.operationType
                ? inputData
                : account
            )
          : [...prevValues.assignedLedgerAccounts, inputData],
      }))
    },
    [setValues]
  )
}
